import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  dark = false
}: SectionHeadingProps) {
  return <div className="text-center" data-id="element-316" data-mp="3f1lxly0rgebe">
      {eyebrow && <p className={`text-xs sm:text-sm font-bold uppercase tracking-[0.18em] ${dark ? 'text-gold-light' : 'text-gold-dark'}`} data-id="element-317" data-mp="3f36rrmj5xv8q">{eyebrow}</p>}
      <h2 className={`mt-3 font-serif text-[32px] leading-[1.1] sm:text-5xl font-black ${dark ? 'text-white' : 'text-ink'}`} data-id="element-318" data-mp="bk3o7m5caz8v">{title}</h2>
    </div>;
}